import { render, staticRenderFns } from "./GroupInvite.vue?vue&type=template&id=650df138&"
import script from "./GroupInvite.vue?vue&type=script&lang=js&"
export * from "./GroupInvite.vue?vue&type=script&lang=js&"
import style0 from "./GroupInvite.vue?vue&type=style&index=0&id=650df138&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports